export default __webpack_public_path__ + "static/media/ultrasonic.f06310c1.svg";